import React from 'react';
import Header from './components/Header';
import SlideBanner from './components/SlideBanner';
import LoveCounter from './components/LoveCounter';
import ImageGallery from './components/ImageGallery';
import BackgroundMusic from './components/BackgroundMusic';
import './App.css';

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <Header />
      <SlideBanner />
      <LoveCounter />
      <ImageGallery />
      <BackgroundMusic />
    </div>
  );
}

export default App;
